/* eslint-disable react/no-unstable-nested-components */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Collapse } from 'react-bootstrap';
import { Col, Row } from 'reactstrap';
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import Login from '../../pages/auth/Login';
import { ConsultaHelper, NumberHelper } from '../../../../shared/helpers';
import {
    changeAutoridadeDetalhes,
    changeSubmenuSelected
} from "../../../../store/ducks/dadosAcervo";

import VisualizadorPdfV2 from '../Home/VisualizadorPdfV2';
import { CreativeCommonsHelper } from '../../../../shared/helpers/CreativeCommonsHelper';
import MediaView from '../Home/MediaView';
import Button from '../../../consulta-acessibilidade/Button';

const OpenModalRender = ({ t, descricao, flag }) => {
    const title = flag === 'AC'
        ? t('CliqueAcessarMaterialAcessibilidade')
        : t('CliqueAcessarMaterialAcessoRestrito');

    return (
        <span className="link hover1 f500 azul" title={title}>
            <FontAwesomeIcon
                icon={flag === 'AC' ? 'universal-access' : 'lock'}
                className={`s13 r5 ${flag === 'AC' ? '' : 'preto70'}`}
            />
            {descricao}
        </span>
    );
};

const AltRenderLoginAcessibilidade = ({ t, auth, data, instituicaoRx, codAcervo, descricao }) => {
    if (auth) {
        if (data.is_pdf) {
            const { usa_visualizador_php } = instituicaoRx;
            if ((usa_visualizador_php && usa_visualizador_php === '1') || data?.link_data?.download_pdf === 'N') {
                return (
                    <span className="f500">
                        <VisualizadorPdfV2
                            codAcervo={codAcervo}
                            seqParagrafo={data.seq_paragrafo}
                            isRestricted
                        />
                        {descricao}
                    </span>
                );
            }
        } else if (data.link_data?.is_media) {
            return (
                <span className="f500">
                    <MediaView
                        title={descricao}
                        uri={data.link_acesso}
                        format={data.link_data.media_format}
                    />
                    {descricao}
                </span>
            );
        }

        return (
            <span
                className="link hover1 f500 azul"
                title={t('CliqueAcessarMaterialAcessibilidade')}
                onClick={() =>
                    ConsultaHelper.acessarLinkAcessoRestrito(
                        codAcervo,
                        data.seq_paragrafo,
                    )
                }
            >
                <FontAwesomeIcon
                    icon="universal-access"
                    className="s13 r5"
                />
                {descricao}
            </span>
        );
    }

    return null;
};

const AltRenderLoginAcessoRestrito = ({
    t,
    auth,
    data,
    instituicaoRx,
    codAcervo,
    descricao,
    isOpenMediaViewOnLogin,
    setIsOpenMediaViewOnLogin
}) => {
    const verifyOpen = (seqParagrafo) => {
        if (isOpenMediaViewOnLogin) {
            const { seq_paragrafo } = isOpenMediaViewOnLogin;
            if (seqParagrafo === seq_paragrafo) {
                return true;
            }
        }
        return false;
    };

    if (auth) {
        if (data.is_pdf) {
            const { usa_visualizador_php } = instituicaoRx;
            if ((usa_visualizador_php && usa_visualizador_php === '1') || data?.link_data?.download_pdf === 'N') {
                return (
                    <span className="f500">
                        <VisualizadorPdfV2
                            codAcervo={codAcervo}
                            seqParagrafo={data.seq_paragrafo}
                            isRestricted
                        />
                        {descricao}
                    </span>
                );
            }
        } else if (data.link_data?.is_media) {
            return (
                <span className="f500">
                    <MediaView
                        open={verifyOpen(data.seq_paragrafo)}
                        codAcervo={codAcervo}
                        isRestricted
                        seqParagrafo={data.seq_paragrafo}
                        title={descricao}
                        uri={data.link_acesso}
                        format={data.link_data.media_format}
                        onClosed={() => setIsOpenMediaViewOnLogin(undefined)}
                    />
                    {descricao}
                </span>
            );
        }

        return (
            <span
                className="link hover1 f500 azul"
                title={t('CliqueAcessarMaterialAcessoRestrito')}
                onClick={() =>
                    ConsultaHelper.acessarLinkAcessoRestrito(
                        codAcervo,
                        data.seq_paragrafo,
                    )
                }
            >
                <FontAwesomeIcon
                    icon="lock-open"
                    className="s13 preto70 r5"
                />
                {descricao}
            </span>
        );
    }

    return null;
};

const CampoDadosAcervo = ({ codAcervo, campo, viewModeBiblioteca }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const instituicaoRx = useSelector(state => state.instituicao.data);
    const guiasPesquisaRx = useSelector(state => state.pageConfig.guiasPesquisa);
    const opcoesResultadoRx = useSelector(state => state.pesquisa.opcoesResultado);

    const [isOpenViewPdfRestrictedOnce, setIsOpenViewPdfRestrictedOnce] = useState(null);
    const [isOpenMediaViewOnLogin, setIsOpenMediaViewOnLogin] = useState(undefined);
    const [isOpenCollapse, setIsOpenCollapse] = useState(false);

    const { qtde_min_seq_paragrafo, url_php } = instituicaoRx;

    const isValidAuthorityCode = (value) => {
        if (value === null || value === undefined) return false;

        const normalizado = String(value).trim();

        return normalizado !== '' && normalizado !== '-1' && normalizado !== '0' && normalizado.toLowerCase() !== 'null';
    };

    const handleClickDetails = (codAutoridade) => {
        dispatch(changeAutoridadeDetalhes(codAutoridade));
        dispatch(changeSubmenuSelected({
            parent: '0',
            submenu: 'detalhes',
            name: t('Detalhes')
        }));
    };

    const regraLupa = (data, indiceAtual) => {
        if (!data.cod_autoridade || data.cod_autoridade.length === 0) {
            return false;
        }

        const codAtual = data.cod_autoridade[indiceAtual];

        if (!isValidAuthorityCode(codAtual)) {
            return false;
        }

        const indicesComMesmoCodAutoridade = data.cod_autoridade
            .map((cod, idx) => cod === codAtual ? idx : null)
            .filter(idx => idx !== null);

        if (indicesComMesmoCodAutoridade.length === 1 && indicesComMesmoCodAutoridade[0] === indiceAtual) {
            return true;
        }

        const maiorIndice = Math.max(...indicesComMesmoCodAutoridade);
        if (maiorIndice !== indiceAtual) {
            return false;
        }

        const existeOutro = indicesComMesmoCodAutoridade.some(idx => {
            if (idx === indiceAtual) return false;

            if (data.gerar_pesquisa && data.gerar_pesquisa[idx] && data.gerar_pesquisa[idx].endsWith('C')) {
                return true;
            }

            if (data.contem_autoridade_completa && data.contem_autoridade_completa[idx]) {
                return true;
            }

            return false;
        });

        return existeOutro;
    };

    const getUrl = (url) => {
        if (url === null || url?.trim() === '') {
            return '';
        }

        const pattern = /^http|https|ftp/;
        if (!pattern.test(url.trim())) {
            return `http://${url.trim()}`;
        }

        return url;
    };

    const getUrlGeraPesquisa = (codAutoridade, descricao, paramFor) => {
        if (isValidAuthorityCode(codAutoridade)) {
            return `/autoridades?q=${codAutoridade}&for=AUTORIDADE_TODOS&aut_id=${codAutoridade}`;
        }

        const usaParametrosPaginada =
            guiasPesquisaRx.find(guia => guia.codigo === 'pesquisa_geral')?.usa_consulta_paginada || false;

        let baseResearchUrl = `/pesquisa_geral?q=${descricao.trim()}&for=${paramFor}&research=true`;
        const orderBy = opcoesResultadoRx.ordenacaoCombo || 'obra';

        if (usaParametrosPaginada) {
            baseResearchUrl += `&page=1&perPage=20&orderBy=${orderBy}&direction=${orderBy === 'ano_publicacao' ? 'D' : 'C'}`;
        }

        return baseResearchUrl;
    };

    const temSubcampoUEm856 = (data) => {
        if (NumberHelper.parseInt(data?.paragrafo) !== 856) {
            return false;
        }

        return Array.isArray(data?.extra) && data.extra.some(item => item?.secao === 'u');
    };

    const deveRenderizarVinculo856 = (data, contSeqSecao) => {
        if (NumberHelper.parseInt(data?.paragrafo) !== 856) {
            return true;
        }

        const possuiSubcampoU = temSubcampoUEm856(data);
        if (!possuiSubcampoU) {
            return false;
        }

        if ((data?.descricao?.length || 0) === 1 && (data?.extra?.length || 0) > 1) {
            return contSeqSecao === 0;
        }

        const secaoAtual = data?.extra?.[contSeqSecao]?.secao;
        return secaoAtual === 'u';
    };

    const renderTextoSimples = (data, descricao, contSeqSecao, pontuacao = '') => (
        <span
            key={`info__${data.paragrafo}${contSeqSecao}`}
            className={`f500 ${contSeqSecao !== 0 ? 'l5' : ''}`}
            style={{ whiteSpace: 'pre-line' }}
            dangerouslySetInnerHTML={{
                __html: `${descricao
                    .replaceAll("<br />\n", "\n")
                    .replaceAll("<br />", "\n")
                    .replaceAll("<br/>", "\n")
                    .replaceAll("<br>", "\n")}${pontuacao}`
            }}
        />
    );

    const renderVinculoAcessibilidade = (data, contSeqSecao, descricao) => {
        return (
            <div
                key={`link__${data.paragrafo}${contSeqSecao}`}
                className="t5 b5"
            >
                <Login
                    modal
                    openModalRender={() => OpenModalRender({ t, descricao, flag: data.link_acesso })}
                    altRender={auth => (
                        <AltRenderLoginAcessibilidade
                            t={t}
                            auth={auth}
                            data={data}
                            instituicaoRx={instituicaoRx}
                            codAcervo={codAcervo}
                            descricao={descricao}
                        />
                    )}
                    loginCallback={() => {
                        if (data.is_pdf) {
                            const { usa_visualizador_php } = instituicaoRx;
                            if ((usa_visualizador_php && usa_visualizador_php === '1') || data?.download_pdf === 'N') {
                                setIsOpenViewPdfRestrictedOnce({ seqParagrafo: data.seq_paragrafo });
                                return;
                            }
                        } else if (data.link_data?.is_media) {
                            setIsOpenMediaViewOnLogin({
                                seq_paragrafo: data.seq_paragrafo
                            });
                            return;
                        }

                        ConsultaHelper.acessarLinkAcessoRestrito(codAcervo, data.seq_paragrafo);
                    }}
                />
                {
                    isOpenViewPdfRestrictedOnce !== null && isOpenViewPdfRestrictedOnce?.seqParagrafo === data.seq_paragrafo ? (
                        <VisualizadorPdfV2
                            codAcervo={codAcervo}
                            seqParagrafo={data.seq_paragrafo}
                            isRestrictedOnce
                            isOpen
                            setIsOpenViewPdfRestrictedOnce={setIsOpenViewPdfRestrictedOnce}
                        />
                    ) : ''
                }
            </div>
        );
    };

    const renderVinculoAcessoRestrito = (data, contSeqSecao, descricao) => {
        return (
            <div
                key={`link__${data.paragrafo}${contSeqSecao}`}
                className="t5 b5"
            >
                <Login
                    modal
                    msgErroCustom={data.msg_err_login}
                    openModalRender={() => OpenModalRender({ t, descricao, flag: data.link_acesso })}
                    altRender={auth => (
                        <AltRenderLoginAcessoRestrito
                            t={t}
                            auth={auth}
                            data={data}
                            instituicaoRx={instituicaoRx}
                            codAcervo={codAcervo}
                            descricao={descricao}
                            isOpenMediaViewOnLogin={isOpenMediaViewOnLogin}
                            setIsOpenMediaViewOnLogin={setIsOpenMediaViewOnLogin}
                        />
                    )}
                    loginCallback={() => {
                        if (data.is_pdf) {
                            const { usa_visualizador_php } = instituicaoRx;
                            if ((usa_visualizador_php && usa_visualizador_php === '1') || data?.link_data?.download_pdf === 'N') {
                                setIsOpenViewPdfRestrictedOnce({ seqParagrafo: data.seq_paragrafo });
                                return;
                            }
                        } else if (data.link_data?.is_media) {
                            setIsOpenMediaViewOnLogin({
                                seq_paragrafo: data.seq_paragrafo
                            });
                            return;
                        }

                        ConsultaHelper.acessarLinkAcessoRestrito(codAcervo, data.seq_paragrafo);
                    }}
                />
                {
                    isOpenViewPdfRestrictedOnce !== null && isOpenViewPdfRestrictedOnce?.seqParagrafo === data.seq_paragrafo ? (
                        <VisualizadorPdfV2
                            codAcervo={codAcervo}
                            seqParagrafo={data.seq_paragrafo}
                            isRestrictedOnce
                            isOpen
                            setIsOpenViewPdfRestrictedOnce={setIsOpenViewPdfRestrictedOnce}
                        />
                    ) : ''
                }
            </div>
        );
    };

    const renderLinkVinculo = (data, descricao, hrefAncora) => {
        if (data.is_pdf && ((instituicaoRx.usa_visualizador_php && instituicaoRx.usa_visualizador_php === '1') || data?.link_data?.download_pdf === 'N')) {
            return (
                <span className="f500">
                    <VisualizadorPdfV2
                        descricao={descricao}
                        urlPdf={hrefAncora}
                    />
                    {descricao}
                </span>
            );
        }

        if (data.link_data?.is_media) {
            return (
                <span className="f500">
                    <MediaView
                        title={descricao}
                        uri={data.link_acesso}
                        format={data.link_data.media_format}
                    />
                    {descricao}
                </span>
            );
        }

        return (
            <span
                className="link hover1 azul f500"
                title={t('CliqueAcessarMaterialOnline')}
                onClick={() =>
                    ConsultaHelper.acessarVinculo(
                        codAcervo,
                        data.seq_paragrafo,
                        getUrl(hrefAncora),
                    )
                }
            >
                <FontAwesomeIcon
                    icon="link"
                    className="s13 preto70 r5"
                />
                {descricao}
            </span>
        );
    };

    const renderCampoVinculo = (data, descricao, contSeqSecao) => {
        const hrefAncora =
            data.link_acesso === 'VB'
                ? `${url_php.replace(/\/$/, '')}/vinculo/publico/${codAcervo}/seq/${data.seq_paragrafo}/${descricao}`
                : data.link_acesso;

        if (data.link_acesso === 'AC') {
            return renderVinculoAcessibilidade(data, contSeqSecao, descricao);
        }

        if (data.link_acesso === 'AR') {
            return renderVinculoAcessoRestrito(data, contSeqSecao, descricao);
        }

        if (data.link_data?.is_media) {
            return (
                <div key={`link__media_${data.paragrafo}${contSeqSecao}`} className="t5 b5">
                    <span className="f500">
                        <MediaView
                            title={descricao}
                            uri={data.link_acesso}
                            format={data.link_data.media_format}
                        />
                        {descricao}
                    </span>
                </div>
            );
        }

        return (
            <div
                key={`link__${data.paragrafo}${contSeqSecao}`}
                className="t5 b5"
            >
                {renderLinkVinculo(data, descricao, hrefAncora)}
            </div>
        );
    };

    const gerarConteudoCampo = (data, index) => {
        const resultNewMethod = renderFieldContentWithNewRules(data);
        if (resultNewMethod) {
            return resultNewMethod;
        }

        const content = [];
        let gerouLink = true;

        for (let contSeqSecao = 0; contSeqSecao < data.descricao.length; contSeqSecao++) {
            const descricao = data.descricao[contSeqSecao];
            const flagPesquisa = data.gerar_pesquisa ? data.gerar_pesquisa[contSeqSecao] : null;
            let pontuacao = data.pontuacao[contSeqSecao];
            pontuacao = pontuacao == null ? '' : pontuacao;

            const extraAtual = data.extra?.[contSeqSecao] || {};
            const { cod_acervo_link, formatar_link } = extraAtual;

            let codAutoridade = null;
            if (data.cod_autoridade && data.cod_autoridade?.length > 0) {
                codAutoridade = data.cod_autoridade[contSeqSecao];
            }

            const codAutoridadeValido = isValidAuthorityCode(codAutoridade);

            if (!data.gerar_pesquisa || flagPesquisa === "N") {
                if (data.vinculo) {
                    const renderizarVinculo = deveRenderizarVinculo856(data, contSeqSecao);

                    if (NumberHelper.parseInt(data.paragrafo) === 856 && !renderizarVinculo) {
                        gerouLink = false;
                        content.push(
                            renderTextoSimples(data, descricao, contSeqSecao, pontuacao)
                        );
                    } else {
                        content.push(renderCampoVinculo(data, descricao, contSeqSecao));
                    }
                } else {
                    if (data.extra?.[contSeqSecao]?.formatar_link === '1') {
                        if (NumberHelper.parseInt(data.extra?.[contSeqSecao]?.paragrafo) === 985) {
                            const tituloLink = data.descricao985 ? data.descricao985 : descricao;
                            const linkRedirecionamento = data.link_acesso ? data.link_acesso : descricao;

                            if (data.link_acesso) {
                                content.push(
                                    <a
                                        className="link hover1 f500"
                                        title={t('Acessar')}
                                        href={getUrl(linkRedirecionamento)}
                                        target='_blank'
                                        rel='noreferrer'
                                        key={`link_gerar_link__${data.paragrafo}${contSeqSecao}`}
                                    >
                                        <FontAwesomeIcon icon="link" className="s13 preto70 r5" />
                                        {`${tituloLink.replaceAll("<br />\n", "\n")
                                            .replaceAll("<br />", "\n")
                                            .replaceAll("<br/>", "\n")
                                            .replaceAll("<br>", "\n")}${pontuacao}`}
                                    </a>
                                );
                            } else {
                                content.push(
                                    renderTextoSimples(data, descricao, contSeqSecao, pontuacao)
                                );
                            }
                        } else {
                            content.push(
                                <a
                                    className="link hover1 f500"
                                    title={t('Acessar')}
                                    href={getUrl(descricao)}
                                    target='_blank'
                                    rel='noreferrer'
                                    key={`link_gerar_link__${data.paragrafo}${contSeqSecao}`}
                                >
                                    <FontAwesomeIcon icon="link" className="s13 preto70 r5" />
                                    {`${descricao
                                        .replaceAll("<br />\n", "\n")
                                        .replaceAll("<br />", "\n")
                                        .replaceAll("<br/>", "\n")
                                        .replaceAll("<br>", "\n")}${pontuacao}`}
                                </a>
                            );
                        }
                    } else if (data?.isSecaoW && data.isSecaoW[contSeqSecao] === true) {
                        content.push(
                            <Link
                                className="link hover1 f500"
                                title="Consultar acervo"
                                to={data.link_acervo}
                                key={`link_secao_w__${data.paragrafo}${contSeqSecao}`}
                            >
                                {`${descricao}${pontuacao}`}
                            </Link>
                        );
                    } else if (NumberHelper.parseInt(data.extra?.[contSeqSecao]?.paragrafo) === 985 && !data.link_acesso) {
                        content.push(
                            renderTextoSimples(data, descricao, contSeqSecao, pontuacao)
                        );
                    } else if (codAutoridadeValido) {
                        content.push(
                            <Link
                                className="link hover1 f500"
                                title={t('Autoridade')}
                                to={`/autoridade/${codAutoridade}`}
                                key={`autoridade__${data.paragrafo}${contSeqSecao}`}
                            >
                                {`${descricao}${pontuacao}`}
                            </Link>
                        );
                    } else if (NumberHelper.parseInt(data.extra?.[contSeqSecao]?.paragrafo) !== 985) {
                        if (formatar_link === "1" && cod_acervo_link) {
                            content.push(
                                <span
                                    key={`info__${data.paragrafo}${contSeqSecao}`}
                                    className={`f500 ${contSeqSecao !== 0 && 'l5'}`}
                                    style={{ whiteSpace: "pre-line" }}
                                >
                                    <Link to={`/acervo/${cod_acervo_link}`}>
                                        {`${descricao
                                            .replaceAll("<br />\n", "\n")
                                            .replaceAll("<br />", "\n")
                                            .replaceAll("<br/>", "\n")
                                            .replaceAll("<br>", "\n")}${pontuacao}`}
                                    </Link>
                                </span>
                            );
                        } else {
                            gerouLink = false;
                            content.push(
                                renderTextoSimples(data, descricao, contSeqSecao, pontuacao)
                            );
                        }
                    }

                    if (
                        data?.contem_autoridade_completa &&
                        data.contem_autoridade_completa[contSeqSecao] === true &&
                        codAutoridadeValido
                    ) {
                        if (regraLupa(data, contSeqSecao)) {
                            content.push(
                                <a
                                    className="l5 r5"
                                    title={t("Detalhes")}
                                    onClick={() => handleClickDetails(data.cod_autoridade[contSeqSecao])}
                                    key={`link_details__${data.paragrafo}${contSeqSecao}`}
                                >
                                    <FontAwesomeIcon icon="search" className="azul hover1" />
                                </a>
                            );
                        }
                    }
                }
            } else {
                let codAutoridadePesquisa = null;
                if (data.cod_autoridade?.length && data.cod_autoridade.filter(x => isValidAuthorityCode(x)).length > 0) {
                    codAutoridadePesquisa = data.cod_autoridade[contSeqSecao];
                }

                const codAutoridadePesquisaValido = isValidAuthorityCode(codAutoridadePesquisa);

                if (flagPesquisa.startsWith('N') && NumberHelper.parseInt(data.paragrafo) === 710) {
                    if (contSeqSecao === 0) {
                        const descricaoformatadaTratamento = data.descricao.filter((desc, i) => isValidAuthorityCode(data.cod_autoridade[i]));
                        const descricaoformatada710 = descricaoformatadaTratamento.join('.');
                        const query = getUrlGeraPesquisa(codAutoridadePesquisa, descricaoformatada710.trim(), 'AUTOR');

                        content.push(
                            <Link
                                className="link hover1 f500"
                                title={t('ConsultarPorAutor')}
                                to={query}
                                target='_blank'
                                key={`link_subject__${data.paragrafo}${contSeqSecao}`}
                            >
                                {descricaoformatada710}
                            </Link>
                        );
                    }
                }

                if (flagPesquisa === 'LE') {
                    content.push(
                        <a
                            className="link hover1 f500"
                            title={t("ConsultarPorAutor")}
                            href={descricao}
                            target='_blank'
                            rel="noreferrer"
                            key={`link_details__${data.paragrafo}${contSeqSecao}`}
                        >
                            {descricao}
                        </a>
                    );
                }

                if (
                    flagPesquisa.startsWith('A') ||
                    (flagPesquisa.startsWith('N') && NumberHelper.parseInt(data.paragrafo) !== 710)
                ) {
                    if (viewModeBiblioteca) {
                        if (codAutoridadePesquisaValido) {
                            content.push(
                                <Link
                                    className="link hover1 f500"
                                    title={t('Autoridade')}
                                    to={`/autoridade/${codAutoridadePesquisa}`}
                                    target='_blank'
                                    key={`link_author_${data.paragrafo}${contSeqSecao}__${data.cod_autoridade[contSeqSecao]}`}
                                >
                                    {`${descricao}${pontuacao}`}
                                </Link>
                            );
                        } else {
                            gerouLink = false;
                            content.push(
                                renderTextoSimples(data, descricao, contSeqSecao, pontuacao)
                            );
                        }
                    } else {
                        const query = getUrlGeraPesquisa(codAutoridadePesquisa, descricao, 'AUTOR');
                        content.push(
                            <Link
                                className="link hover1 f500"
                                title={t('ConsultarPorAutor')}
                                to={query}
                                target='_blank'
                                key={`link_author__${data.paragrafo}${contSeqSecao}`}
                            >
                                {`${descricao}${pontuacao}`}
                            </Link>
                        );
                    }
                } else if (flagPesquisa.startsWith('T')) {
                    const query = getUrlGeraPesquisa(codAutoridadePesquisa, descricao, 'ASSUNTO');

                    if (viewModeBiblioteca) {
                        if (codAutoridadePesquisaValido) {
                            data.cod_autoridade.forEach((cod_autoridade, i) => {
                                if (!isValidAuthorityCode(cod_autoridade)) {
                                    return;
                                }

                                if (i > 0) {
                                    content.push(data.pontuacao[i]);
                                }

                                content.push(
                                    <Link
                                        className="link hover1 f500"
                                        title={t('Autoridade')}
                                        to={`/autoridade/${cod_autoridade}`}
                                        target='_blank'
                                        key={`link_subject__${data.paragrafo}${contSeqSecao}${cod_autoridade}`}
                                    >
                                        {data.descricao[i]}
                                    </Link>
                                );
                            });
                        } else {
                            gerouLink = false;
                            content.push(
                                renderTextoSimples(data, descricao, contSeqSecao, pontuacao)
                            );
                        }
                    } else {
                        content.push(
                            <Link
                                className="link hover1 f500"
                                title={t('ConsultarPorAssunto')}
                                to={query}
                                target='_blank'
                                key={`link_subject__${data.paragrafo}${contSeqSecao}`}
                            >
                                {`${descricao}${pontuacao}`}
                            </Link>
                        );
                    }
                } else if (flagPesquisa.startsWith('W')) {
                    const query = getUrlGeraPesquisa(codAutoridadePesquisa, descricao, 'TITULO');

                    if (data?.isSecaoW && data.isSecaoW[contSeqSecao] === true) {
                        content.push(
                            <Link
                                className="link hover1 f500"
                                title="Consultar acervo"
                                to={data.link_acervo}
                                target='_blank'
                                key={`link_secao_w__${data.paragrafo}${contSeqSecao}`}
                            >
                                {`${descricao}${pontuacao}`}
                            </Link>
                        );
                    } else {
                        content.push(
                            <Link
                                className="link hover1 f500"
                                title={t('ConsultarPorAssunto')}
                                to={query}
                                target='_blank'
                                key={`link_titulo__${data.paragrafo}${contSeqSecao}`}
                            >
                                {`${descricao}${pontuacao}`}
                            </Link>
                        );
                    }
                }

                if (flagPesquisa.endsWith("C") && codAutoridadePesquisaValido) {
                    if (regraLupa(data, contSeqSecao)) {
                        content.push(
                            <a
                                className="l5 r5"
                                title={t("Detalhes")}
                                onClick={() => {
                                    handleClickDetails(data.cod_autoridade[contSeqSecao]);
                                }}
                                key={`link_details__${data.paragrafo}${contSeqSecao}`}
                            >
                                <FontAwesomeIcon icon="search" className="azul hover1" />
                            </a>
                        );
                    }
                }
            }
        }

        const usaEspacamentoEntreSeqParagrafos =
            campo.detalhes.length > 1 &&
            !gerouLink &&
            index !== campo.detalhes.length - 1;

        return (
            <div
                key={`seqPar${data.seq_paragrafo}`}
                style={{ display: data.vinculo ? 'inline' : 'inline-block' }}
                className={`s14 text-justify ${usaEspacamentoEntreSeqParagrafos ? 'pb-3' : ''}`}
            >
                {content}
            </div>
        );
    };

    const renderFieldContentWithNewRules = (data) => {
        const renderFieldCreativeCommons = (fieldData) => {
            const secaoA = fieldData.extra.find(x => x.secao === 'a');
            const secaoB = fieldData.extra.find(x => x.secao === 'b');

            const { descricao: author } = secaoA;
            const { descricao: licenseType } = secaoB;

            return (
                <div style={{ display: 'inline-block' }} className="s14 text-justify">
                    {CreativeCommonsHelper().getHtml(licenseType, author)}
                </div>
            );
        };

        const renderField773 = (fieldData) => {
            const wSectionIndex = fieldData?._secao.findIndex(x => x.trim().toLowerCase() === 'w');
            const tSectionIndex = fieldData?._secao.findIndex(x => x.trim().toLowerCase() === 't');

            const linkByCollectionCode = wSectionIndex > -1;
            const linkAcervo = linkByCollectionCode ? fieldData?.link_acervo : undefined;
            const codAutoridade = !linkByCollectionCode ? fieldData?.cod_autoridade[tSectionIndex] : undefined;
            const codAutoridadeValido = isValidAuthorityCode(codAutoridade);

            const linkTo = linkByCollectionCode
                ? linkAcervo
                : codAutoridadeValido
                    ? `/autoridade/${codAutoridade}`
                    : null;

            const linkTooltip = linkByCollectionCode ? t('Acervo') : t('Autoridade');
            const texto = fieldData.descricao.map((description, i) => {
                const punctuation = fieldData?.pontuacao[i];
                return `${description}${punctuation}`;
            });

            return (
                <div
                    key={fieldData.seq_paragrafo}
                    style={{ display: fieldData.vinculo ? 'inline' : 'inline-block' }}
                    className="s14 text-justify"
                >
                    {linkTo ? (
                        <Link
                            className="link hover1 f500"
                            title={linkTooltip}
                            to={linkTo}
                            key="link_773"
                        >
                            {texto}
                        </Link>
                    ) : (
                        <span className="f500">{texto}</span>
                    )}
                </div>
            );
        };

        if (data?.isCreativeCommons) {
            return renderFieldCreativeCommons(data);
        }

        const renderField984 = (fieldData) => {
            if (!fieldData.link_acesso || !fieldData.descricao984) {
                return undefined;
            }

            return (
                <div
                    key={fieldData.seq_paragrafo}
                    style={{ display: 'inline-block' }}
                    className="s14 text-justify"
                >
                    <a
                        className="link hover1 f500"
                        title={t('Acessar')}
                        href={getUrl(fieldData.link_acesso)}
                        target='_blank'
                        rel='noreferrer'
                    >
                        <FontAwesomeIcon icon="link" className="s13 preto70 r5" />
                        {fieldData.descricao984}
                    </a>
                </div>
            );
        };

        switch (NumberHelper.parseInt(data.paragrafo)) {
            case 773:
                return renderField773(data);
            case 984:
                return renderField984(data);
            default:
                return undefined;
        }
    };

    if (viewModeBiblioteca) {
        return (
            <div
                key={`field__${campo.ordem}`}
                className="flex-column"
                style={{ gap: '16px' }}
            >
                <span className="font-weight-bold s14 mb-1 preto70">
                    {campo.texto}
                </span>
                <div className="d-flex flex-column px-1">
                    {campo.detalhes.map((detalhe, index) => (
                        <div className="preto50" key={index}>
                            {gerarConteudoCampo(detalhe, index)}
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    const renderFieldContent = () => {
        if (!campo?.detalhes?.length) return '';

        const { detalhes } = campo;

        const handleToggleCollapse = () => {
            setIsOpenCollapse(!isOpenCollapse);
        };

        if (detalhes.length > 1) {
            if (qtde_min_seq_paragrafo) {
                const visibleFields = detalhes.slice(0, qtde_min_seq_paragrafo).map((fv, index) => (
                    <div key={index} style={{ display: 'block' }}>
                        {gerarConteudoCampo(fv, index)}
                    </div>
                ));

                const fieldsToSeeMore = detalhes.slice(qtde_min_seq_paragrafo).map((ftsm, index) => (
                    <div key={index} style={{ display: 'block' }}>
                        {gerarConteudoCampo(ftsm, index + qtde_min_seq_paragrafo)}
                    </div>
                ));

                return (
                    <>
                        {visibleFields}
                        {fieldsToSeeMore && fieldsToSeeMore?.length > 0 ? (
                            <>
                                <Collapse className='' in={isOpenCollapse}>
                                    <div>
                                        {fieldsToSeeMore}
                                    </div>
                                </Collapse>

                                <Button
                                    onClick={handleToggleCollapse}
                                    title={isOpenCollapse ? t('VerMenos') : t('VerMais')}
                                    icon={isOpenCollapse ? faAngleUp : faAngleDown}
                                    variant='segundo ml-0 mt-1'
                                />
                            </>
                        ) : ''}
                    </>
                );
            }

            return detalhes.map((d, index) => (
                <div key={index} style={{ display: 'block' }}>
                    {gerarConteudoCampo(d, index)}
                </div>
            ));
        }

        return (
            <div style={{ display: 'block' }}>
                {gerarConteudoCampo(detalhes[0], 0)}
            </div>
        );
    };

    return (
        <Row className="b-w1 b-cinza2 b-solid-bottom pad5 b5 corAlto1">
            <Col xs="12" md="3">
                <span className="f400 preto70 s14">{campo.texto}: </span>
            </Col>
            <Col xs="12" md="9">
                {renderFieldContent()}
            </Col>
        </Row>
    );
};

CampoDadosAcervo.propTypes = {
    campo: PropTypes.object.isRequired,
    viewModeBiblioteca: PropTypes.bool.isRequired,
};

export default CampoDadosAcervo;